import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Button from '@/components/inputs/button'
import Dialog from '@/components/shared/dialog'

interface CookieConsentDialogProps {
    open: boolean
    onAccept: () => void
    onReject: () => void
}

const CookieConsentDialog = ({ open, onAccept, onReject }: CookieConsentDialogProps) => {
    const { t } = useTranslation()

    return (
        <Dialog
            title={t('titleCookieConsent')}
            dialogId="cookie_consent"
            open={open}
            displayCloseButton={false}
            className="w-[calc(100%-1rem)] max-w-lg"
        >
            <div className="flex flex-col gap-y-4 pb-4">
                <p>{t('cookieConsentBody')}</p>
                <p>
                    <Link
                        className="underline"
                        to="/privacy"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t('cookieConsentPrivacyLink')}
                    </Link>
                </p>
                <div className="flex flex-col-reverse gap-2 md:flex-row md:justify-end">
                    <Button wideOnMobile type="button" onClick={onReject}>
                        {t('buttonRejectCookies')}
                    </Button>
                    <Button wideOnMobile type="button" design="primary" onClick={onAccept}>
                        {t('buttonAcceptCookies')}
                    </Button>
                </div>
            </div>
        </Dialog>
    )
}

export default CookieConsentDialog
